import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import styles from "./GuestSaveBanner.module.css";

/**
 * Trial reminder + conversion entry point. Renders nothing for real accounts, so
 * screens can mount it unconditionally.
 */
export default function GuestSaveBanner({ className }) {
  const { isGuest } = useAuth();
  const navigate = useNavigate();

  if (!isGuest) return null;

  return (
    <aside className={[styles.root, className].filter(Boolean).join(" ")}>
      <p className={styles.copy}>
        You&apos;re trying Gift Gaff. Create an account to save your giftees.
      </p>
      <button
        type="button"
        className={styles.cta}
        onClick={() => navigate("/auth?intent=create-account")}
      >
        Create account
      </button>
    </aside>
  );
}
